module.exports = __webpack_public_path__ + "img/chunks-2.cea1a727.jpg";